import { newSize } from '@lessonup/pin-renderer';

// Sizes for the StudentJoin and Ranking screens, these will get scaled
export const playerScreenSize = newSize(960, 540);
